export const setArtBoardSize = (self, { width, height }) => {
  self._checkNoProcessingTask();
  const art_board = self._getArtBoardThrowable();
  art_board.resize({
    width,
    height,
  });
};
